module.exports = __webpack_public_path__ + "img/airplane-3.10634034.jpg";